import DropdownToggle from "components/dropdown-toggle/DropdownToggle";
import { Dropdown } from "react-bootstrap";
import { AmplitudePageName, track } from "utils/amplitude";

export const APPOINTMENT_TYPES_SELECT_EMPTY_OPTION = {
  label: "Select a Session Type...",
};

export type AppointmentTypesSelectOption =
  | SessionType
  | typeof APPOINTMENT_TYPES_SELECT_EMPTY_OPTION;

interface AppointmentTypesSelectProps {
  appointmentTypes: SessionType[];
  orchidPro: OrchidPro;
  amplitudeComponentName?: string;
  amplitudePageName?: AmplitudePageName;
  selectedType?: AppointmentTypesSelectOption;
  setSelectedType: React.Dispatch<
    React.SetStateAction<AppointmentTypesSelectOption>
  >;
}

const AppointmentTypesSelect = ({
  appointmentTypes,
  orchidPro,
  selectedType,
  amplitudeComponentName,
  amplitudePageName,
  setSelectedType,
}: AppointmentTypesSelectProps) => {
  return (
    <>
      <div className="rg-12 gray01 mb-1">Session type</div>
      <DropdownToggle
        title={
          !orchidPro.can_accept_payment
            ? "Cannot accept payment"
            : appointmentTypes.length === 0
            ? "No available sessions"
            : selectedType?.label
        }
        className={"mb-3"}
        disabled={
          !orchidPro.can_accept_payment || appointmentTypes.length === 0
        }
        onClick={() =>
          amplitudePageName &&
          amplitudeComponentName &&
          track(
            amplitudePageName,
            [amplitudeComponentName, "session-type-dropdown"],
            "click",
          )
        }
      >
        {appointmentTypes.map((type) => (
          <Dropdown.Item key={type.label} onClick={() => setSelectedType(type)}>
            {type.label}
          </Dropdown.Item>
        ))}
      </DropdownToggle>
    </>
  );
};

export default AppointmentTypesSelect;
